import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { TimesheetService } from './../../../../../core/services/services/timesheet.service';
import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PrimeNGConfig } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';

export function monthYearValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    const isValid = /^\d{4}-\d{2}$/.test(value);
    return !isValid ? { 'invalidMonthYear': { value } } : null;
  };
}
@Component({
  selector: 'app-list-timesheet',
  templateUrl: './list-timesheet.component.html',
  styleUrls: ['./list-timesheet.component.css'],
})
export class ListTimesheetComponent {
  currentYear!: number;
  currentUser: any;
  id: any;
  listOfMonths: any;
  clientFinal_id: any;
  listCra: any;
  sortAttr = '';
  totalItems!: number;
  currentSortDirection: number = 2;
  pagination : boolean =false;

  itemsPerPage: number = 5;
  currentPage: number = 1;
  listWorkFlowClient: any;
  startIndex: number = 0;
  endIndex: number = 5;
  idtimesheet: any;
  message: any;
  state = [
    { id: 1, name: 'en attente' },
    { id: 2, name: 'Validé' },
    { id: 3, name: 'Rejeté' },
  ];
  private unsubscribeAll: Subject<void> = new Subject();
  searchForm: FormGroup = this.createSearchForm();
  calendarLocale: any;
  monthNames: string[] = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
  constructor(
    private Timeshettservice: TimesheetService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private router: Router,
    private localStorageService: LocalStorageService,
    private primengConfig: PrimeNGConfig
  ) { }
  ngOnInit() {
    this.primengConfig.setTranslation({
      dayNames: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi',
      ],
      dayNamesShort: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
      dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
      monthNames: [
        'janvier',
        'février',
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        'août',
        'septembre',
        'octobre',
        'novembre',
        'décembre',
      ],
      monthNamesShort: [
        'janv.',
        'févr.',
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        'août',
        'sept.',
        'oct.',
        'nov.',
        'déc.',
      ],
      today: "Aujourd'hui",
      clear: 'Effacer',
    });
    this.clientFinal_id = this.localStorageService.getData('clientConnected');

    this.getAllListCra();
  }
  getStateTimesheet() {
    console.log(' iddfgdg', this.id);
    this.Timeshettservice.getStateOfftimesheet(this.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('res type activite', res);
          this.message = res.message;
        },
        error: () => { },
      });
  }
  /* list list workflow General */
  getAllListCra() {
    this.spinner.show();
    let dataPyload =
      this.sortAttr == ''
        ? { per_page: this.itemsPerPage, page: this.currentPage }
        : {
          ...{ per_page: this.itemsPerPage, page: this.currentPage },
          ...{
            sort: this.currentSortDirection,
            sortAttribute: this.sortAttr,
          },
        };
    let clientFinal_id = this.localStorageService.getData('clientConnected');
    this.Timeshettservice.getAllListtimesheet(clientFinal_id, dataPyload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          console.log('liste ', res);
          this.listCra = res.data.consultans.data;
        
          this.id = res.data.consultans.data[0].id;
          console.log('this.id ', this.id);
          this.totalItems = res.data.consultans.total;
          this.getStateTimesheet();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  getItems(event?: any) {
    if (
      (event && event.startIndex != this.startIndex) ||
      this.endIndex != event.endIndex ||
      this.itemsPerPage != event.itemsPerPage ||
      this.currentPage != event.currentPage
    ) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchCraState) {
        this.searchCra();
      } else  if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getAllListCra();
      }
    }
  }
  /* search */
  limitYearLength(event: any) {
    const input = event.target.value;
    if (input.length >= 4 && event.keyCode !== 8 && event.keyCode !== 46) {  // 8 is backspace, 46 is delete
      event.preventDefault();
    }
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      consultant_e_s_n_manager_full_name: [
        data ? data.consultant_e_s_n_manager_full_name : '',
      ],
      consultant: [data ? data.consultant : ''],
      month_timeSheet: [data ? this.formatDate(data.month_timeSheet) : ''],

      esn_name: [data ? data.esn_name : ''],
      state: [data ? data.state : null],
      date_cra: [data ? this.formatDate(data.date_cra) : ''],
    });
  }
  onDateChange(date: Date | string): void {
    // Si date est vide ou undefined, réinitialiser le champ
    if (!date || (date instanceof Date && isNaN(date.getTime()))) {
      this.searchForm.get('month_timeSheet')?.setValue(''); // Réinitialiser si la date est invalide ou vide
    } else {
      const formattedDate = this.formatDate(date);
      this.searchForm.get('month_timeSheet')?.setValue(formattedDate);
    }
  }






  limitMonthYearLength(event: KeyboardEvent): void {
    const allowedKeys = [8, 46, 37, 39]; // Backspace, Delete, Left arrow, Right arrow
    if (event.key.length === 1 && !/[\d-]/.test(event.key)) {
      event.preventDefault();
    }
    // Limite le nombre de caractères saisis
    const input = (event.target as HTMLInputElement).value;
    if (input.length >= 7 && !allowedKeys.includes(event.keyCode)) {  // YYYY-MM = 7 caractères
      event.preventDefault();
    }
  }
  onMonthYearInput(event: any): void {
    const value = event.target.value;
    const isValid = /^\d{4}-\d{2}$/.test(value);
    if (!isValid && value.length > 0) {
      console.error('La date entrée est invalide');
    }
  }
  formatDate(date: Date | string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Mois de 01 à 12
    return `${year}-${month}`;
  }
  searchCraState: boolean = false
  searchCra() {
    let data = {
      esn_name: this.searchForm.value?.esn_name,
      consultant_e_s_n_manager_full_name:
        this.searchForm.value.consultant_e_s_n_manager_full_name,
      consultant: this.searchForm.value?.consultant,
      month_timeSheet: this.searchForm.value.month_timeSheet,
      state: this.searchForm.value.state,
      page: this.currentPage,
      per_page: this.itemsPerPage,
    };
    this.spinner.show();
    this.Timeshettservice.searchTimesheet(data, this.clientFinal_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.searchCraState = true
          if ( this.currentPage > 1) {
            this.currentPage = 1;
            this.searchCra();
            this.spinner.hide();
          } else {
            this.listCra = res.data.consultans.data;
            this.totalItems = res.data.consultans.total;
            this.spinner.hide();
          }
        },
        error: () => {
          this.searchCraState = false
          this.spinner.hide();
        },
      });
  }
  detailsNavigation(idCra: string) {
    this.router.navigate([
      '/cra/detail-timesheet/',
      { idCra: idCra },
    ]);
  }
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchCra();
  }

}
